import type { ReactElement } from 'react';
import React from 'react';

import { Box, ThemeConstellation } from '@zillow/constellation';

import { Shimmer } from '../Shimmer/Shimmer';

const RTBCardLoading: React.FC = (): ReactElement => (
    <Box
        className="rtbCardLoading"
        sx={{
            '@media $xl': {
                height: '480px',
            },
            [`@media (min-width: ${ThemeConstellation.constellation.breakpoints.md}px) and (max-width: 596px)`]:
                {
                    height: '480px',
                },
            [`@media (min-width: 597px) and (max-width: ${ThemeConstellation.constellation.breakpoints.xl}px)`]:
                {
                    height: '300px',
                },
            [`@media $sm_lte`]: {
                height: '480px',
            },
        }}
    >
        <Shimmer />
    </Box>
);

export default RTBCardLoading;
